<script setup lang="ts">
import {useRoute} from "vue-router";

const route = useRoute()

const tabs = [
  {
    name: 'Applications',
    route: 'nir-registration-applications',
    icon: 'fa-solid fa-list'
  },
  {
    name: 'Bulk Applications',
    route: 'nir-bulk-applications',
    icon: 'fa-solid fa-list'
  },
  {
    name: 'Forced Registrations',
    route: 'nir-registration-forced-applications',
    icon: 'fa-solid fa-list'
  },
  {
    name: 'Data Update Applications',
    route: 'nir-registration-data-update-applications',
    icon: 'fa-solid fa-list'
  },
  {
    name: 'Amendment Applications',
    route: 'nir-registration-amendment-applications',
    icon: 'fa-solid fa-list'
  },
  // {
  //   name: 'Task Queue',
  //   route: 'nir-registration-task-queue',
  //   icon: 'fa-solid fa-file'
  // },
  {
    name: 'New Bulk Registration',
    route: 'nir-registration-new',
    icon: 'fa-solid fa-file-pen'
  },
]


const isActiveTab = (tabRoute: string) => {
  return route.name === tabRoute
}

</script>

<template>
  <div class="flex-1 flex flex-col overflow-hidden">
    <!-- Tabs -->
    <div class="bg-white">
      <div class="flex flex-col">
        <nav class="flex space-x-6 px-4" aria-label="Tabs">
          <router-link
              v-for="tab in tabs"
              :key="tab.route"
              :to="{ name: tab.route }"
              :class="[
              isActiveTab(tab.route)
                ? 'border-primary text-primary'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
              'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition'
            ]">
            <i :class="tab.icon + ' text-sm'"></i>
            <span>{{ tab.name }}</span>
          </router-link>
        </nav>
      </div>

      <!-- Tab Content -->
      <div class="flex flex-col">
        <RouterView />
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>